import { AsyncPipe, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { PrimeTemplate } from "primeng-v17/api";
import { DropdownModule } from "primeng-v17/dropdown";
import { AppendToBodyDirective } from "../../../shared/primeng/append-to-body/append-to-body.directive";
import { DropdownEditableColumnAutoFocusDirective } from "../../../shared/primeng/dropdown-editable-column-auto-focus/dropdown-editable-column-auto-focus.directive";
import { DropdownHideFixDirective } from "../../../shared/primeng/dropdown-hide-fix/dropdown-hide-fix.directive";
import { DropdownOptionsDirective } from "../../../shared/primeng/dropdown-options/dropdown-options.directive";
import { DropdownPrePopulateSingleOptionDirective } from "../../../shared/primeng/dropdown-pre-populate-single-option/dropdown-pre-populate-single-option.directive";
import { DropdownReadonlyFixDirective } from "../../../shared/primeng/dropdown-readonly-fix/dropdown-readonly-fix.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiCommunicationLanguageComponent } from "./new-ui-communication-language.component";

@Component({
  selector: "app-communication-language",
  templateUrl: "./communication-language.component.html",
  imports: [
    TranslateDirective,
    DropdownModule,
    AppendToBodyDirective,
    DropdownEditableColumnAutoFocusDirective,
    DropdownHideFixDirective,
    DropdownOptionsDirective,
    DropdownPrePopulateSingleOptionDirective,
    DropdownReadonlyFixDirective,
    FormsModule,
    PrimeTemplate,
    NgIf,
    AsyncPipe,
  ],
})
export class CommunicationLanguageComponent extends NewUiCommunicationLanguageComponent {}
